import { Navigate, Outlet } from 'react-router-dom'
import { BrandMark } from './BrandMark'
import { AccountNav } from './AccountNav'
import { hasValidSession } from '../lib/api'

export function AccountLayout() {
  if (!hasValidSession()) {
    return <Navigate to="/login" replace />
  }

  return (
    <div className="account-shell">
      <aside className="account-shell__sidebar">
        <div className="account-shell__wordmark">
          <BrandMark />
          SateLab ID
        </div>
        <AccountNav />
      </aside>

      <header className="account-shell__topbar">
        <div className="account-shell__wordmark">
          <BrandMark />
          SateLab ID
        </div>
      </header>

      <main className="account-shell__main">
        <Outlet />
      </main>

      <div className="account-shell__tabbar">
        <AccountNav />
      </div>
    </div>
  )
}
